import { render, staticRenderFns } from "./RequestTickets.vue?vue&type=template&id=d1bcc608&scoped=true&"
import script from "./RequestTickets.vue?vue&type=script&lang=js&"
export * from "./RequestTickets.vue?vue&type=script&lang=js&"
import style0 from "./RequestTickets.vue?vue&type=style&index=0&id=d1bcc608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bcc608",
  null
  
)

export default component.exports